import React, { useEffect, useState } from 'react';
import './index.scss';
import {
    Button,
    Card,
    Modal,
    Col,
    Divider,
    Image,
    Row,
    Table,
    Typography,
    notification,
    Space,
    Form,
    Switch,
    Input, Upload, Spin, Select, Skeleton,
} from 'antd';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import {
    UploadOutlined,
    ArrowLeftOutlined,
    ExclamationCircleOutlined,
} from '@ant-design/icons';

import API_SERVICE from 'shared/services/api-service';
import { getImageUrl, UploadImage } from 'shared/services/Utility';
import TextArea from 'antd/es/input/TextArea';
import Parameters from 'shared/parameters';
import Password from 'antd/es/input/Password';
import imgIcon from '../../../src/img/image-icon.png';
import arrowLeft from '../../../src/img/arrow-left.png';
import vDOts from '../../../src/img/v-dots.png';
import moment from 'moment';

interface Props {
    location: any;
}

const { Title } = Typography;
const { Option } = Select;
const { confirm } = Modal;
export default function UserForm(props: Props) {
    const [deletingItem, setDeletingItem] = useState(false);
    const { t } = useTranslation();
    const history: any = useHistory();
    const RouteParams: any = useParams();
    const [form] = Form.useForm();
    const [saving, setSaving] = useState(false);
    const [fetching, setFetching] = useState(true);
    const [item, setItem] = useState(null as any);
    const [image, setImage] = useState({ image: null, imageId: null } as any);
    const [uploading, setUploading] = useState(false);
    const [organizations, setOrganizations] = useState([] as any[]);
    const refreshOrganizations = async () => {
        try {
            setFetching(true);
            const {
                data: {
                    data: {
                        items,
                    },
                },
            } = await API_SERVICE.fetchOrganizations({ order_by: 'id', perpage: 100, order: 'DESC' });
            setOrganizations(items);
        } catch (e) {
            notification.error({
                message: t(API_SERVICE.handleErrors(e)),
            });
        } finally {
            setFetching(false);
        }
    };
    const refreshItem = async () => {
        try {
            setFetching(true);
            const {
                data: { data },
            } = await API_SERVICE.fetchUserById(RouteParams['id']);
            setItem({
                ...data,
                type: 'ADMIN',
            });
            setImage({ image: getImageUrl(data.avatar_image), imageId: data.avatar });
        } catch (e) {
            notification.error({
                message: t(API_SERVICE.handleErrors(e)),
            });
        } finally {
            setFetching(false);
        }
    };
    const uploadImage = async (file: any) => {
        setUploading(true);
        setImage({ image: null, imageId: null });
        const { image, imageId, error } = await UploadImage(file);
        if (error) {
            notification.error({ message: error });
        }
        setImage({ image, imageId });
        setUploading(false);
    };
    useEffect(() => {
        if (Parameters.Mode === 'SUPER_ADMIN') {
            refreshOrganizations();
        }
    }, []);
    useEffect(() => {
        if (RouteParams['id']) {
            refreshItem();
        } else {
            setFetching(false);
        }
    }, []);

    if (fetching) {
        return <Skeleton active={true} />;
    }
    console.log(Parameters.Mode);
    return (
        <div className={'list-page-wrapper'}>
            <div className="container-fluid">
                <div className='row mb-3'>
                    <div className='col-md-12 p-0 d-flex align-items-center'>
                        <div className='mr-4'>
                        <span className='bg-back cursor-pointer' onClick={() => history.goBack()}><img src={arrowLeft} className="page-back" /></span>
                        </div>
                        <div><h3 className='mb-0'>{RouteParams['mode'] === 'create' ? t('admin.create') : ''}</h3></div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        {RouteParams['mode'] === 'create' || RouteParams['mode'] === 'edit' ?
                            <div className='bg-white p-3 br-5px'>
                                <div className='pt-3 pb-3 pl-4 pr-6rem'>
                                    <Row>
                                        <Col lg={10} md={10} sm={24} xs={24}>
                                            <h5>Upload Avatar</h5>
                                            <p className="text-secondary">This Information will be display the identify of the administrator</p>
                                        </Col>
                                        <Col lg={14} md={14} sm={24} xs={24}>
                                        {
                                            uploading ? <Spin/> : (
                                                image.image ? <div>
                                                    
                                                    <div className="d-flex align-items-center">
                                                        <div className="uploadeImgBg mr-2">
                                                            <Image src={image.image} id="orgLogo" className="uploaded-img-cat" height={'48px'} width={'48px'}/>
                                                        </div>
                                                        <div>
                                                            {
                                                                RouteParams['mode'] !== 'view' && <Button className='btn btn-default' onClick={() => setImage({
                                                                    image: null,
                                                                    imageId: null,
                                                                })}>{t('genDict.remove')}</Button>
                                                                
                                                            }
                                                        </div>
                                                    </div>
                                                    
                                                </div> : <Upload beforeUpload={(file) => {
                                                            if (!(file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
                                                                notification.error({ message: `PNG/JPG/JPEG ${t('genDict.required')}` });
                                                            }
                                                                uploadImage(file);
                                                                return file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg';
                                                            }}>
                                                            <div className="d-flex align-items-center">
                                                                <div className="mr-2">
                                                                        <img src={imgIcon} className="logo-org"/>
                                                                    {/* <i className="fa fa-picture-o logo-org"></i> */}
                                                                    {/* <img src="#" id="orgLogo" className="uploaded-img-cat" height="48" width="48" style={{display:'none'}}/> */}
                                                                </div>
                                                                <div>
                                                                    <Button className="btn btn-default">{t('genDict.uploadImage')}</Button>
                                                                </div>
                                                            </div>
                                                        </Upload>
                                            )
                                        }
                                        </Col>
                                    </Row>
                                    <hr/>
                                    <Form
                                        size='large'
                                        form={form}
                                        initialValues={item}
                                        fields={[]}
                                        onFinish={(value) => {
                                            if (!image.imageId) {
                                                notification.error({ message: t('user.image.required') });
                                                return;
                                            }
                                            const reqObj: any = value;
                                            reqObj['avatar'] = image.imageId;
                                            setSaving(true);
                                            if (item && item.id) {
                                                if (!reqObj['password']) {
                                                    delete reqObj['password'];
                                                    delete reqObj['password_confirmation'];
                                                }
                                                API_SERVICE.updateUser(item.id, reqObj).then((d) => {
                                                    history.goBack();
                                                }).catch((e) => {
                                                    notification.error({ message: API_SERVICE.handleErrors(e) });
                                                    setSaving(false);
                                                });
                                            } else {
                                                API_SERVICE.createUser(reqObj).then((d) => {
                                                    history.goBack();
                                                }).catch((e) => {
                                                    notification.error({ message: API_SERVICE.handleErrors(e) });
                                                    setSaving(false);
                                                });
                                            }
                                        }}
                                        layout='vertical'
                                        requiredMark={true}
                                    >
                                        <Row>
                                            <Col lg={10} md={10} sm={24} xs={24} className="mt-4">
                                                <h5>Admin's Information</h5>
                                                <p className="text-secondary">This Information will be display the identify of the administrator</p>
                                            </Col>
                                            
                                            <Col lg={14} md={14} sm={24} xs={24} className="mt-4">
                                            
                                            <Form.Item
                                                label={t('user.type.label')}
                                                name='type'
                                                rules={[
                                                    { required: RouteParams['mode'] === 'create', message: t('user.type.required') },
                                                ]}
                                            >
                                                <Select className='br-1' disabled={RouteParams['mode'] !== 'create'}>
                                                    <Option value={'ADMIN'}>{t('genDict.' + 'ADMIN')}</Option>;
                                                </Select>
                                            </Form.Item>
                                            {
                                                Parameters.Mode === 'SUPER_ADMIN' && <Form.Item
                                                    label={t('genDict.organization')}
                                                    name='organizations_id'
                                                    rules={[
                                                        {
                                                            required: RouteParams['mode'] === 'create',
                                                            message: t('user.organization.required'),
                                                        },
                                                    ]}
                                                >
                                                    <Select className='br-1'  >
                                                        {
                                                            organizations.map((a) => {
                                                                return <Option value={a.id}>{a.name}</Option>;
                                                            })
                                                        }
                                                    </Select>
                                                </Form.Item>
                                            }

                                            <Form.Item
                                                label={t('user.name.label')}
                                                name='name'
                                                rules={[
                                                    { required: true, message: t('user.name.required') },
                                                ]}
                                            >
                                                <Input className='form-control' disabled={RouteParams['mode'] === 'view'} />
                                            </Form.Item>
                                            <Row>
                                                <Col lg={12} md={12} sm={24} xs={24} className="pr-sm-2">
                                                <Form.Item
                                                    label={t('user.email.label')}
                                                    name='email'
                                                    rules={[
                                                        { required: true, type: 'email', message: t('user.email.required') },
                                                    ]}
                                                >
                                                    <Input className='form-control' disabled={RouteParams['mode'] !== 'create'} />
                                                </Form.Item>
                                                </Col>
                                                <Col lg={12} md={12} sm={24} xs={24} className="pl-sm-2">
                                                <Form.Item
                                                    label={t('user.phone.label')}
                                                    name='phone'
                                                    rules={[
                                                        { required: true, message: t('user.phone.required') },
                                                    ]}
                                                >
                                                    <Input className='form-control' disabled={RouteParams['mode'] === 'view'} />
                                                </Form.Item>
                                                </Col>
                                            </Row>
                                            
                                                
                                                <Form.Item
                                                    label={t('user.gender.label')}
                                                    name='gender'
                                                    rules={[
                                                        { required: true, message: t('user.gender.required') },
                                                    ]}
                                                >
                                                    <Select className='br-1' disabled={RouteParams['mode'] === 'view'}>
                                                        {
                                                            ['male', 'female'].map((a) => {
                                                                return <Option value={a}>{t('genDict.' + a)}</Option>;
                                                            })
                                                        }
                                                    </Select>
                                                </Form.Item>
                                                <Form.Item
                                                    label={t('user.jobTitle.label')}
                                                    name='job_title'
                                                    rules={[]}
                                                >
                                                    <Input className='form-control' disabled={RouteParams['mode'] === 'view'} />
                                                </Form.Item>
                                                <Form.Item
                                                    label={t('user.aboutMe.label')}
                                                    name='about_me'
                                                    rules={[]}
                                                >
                                                    <TextArea className='form-control' rows={4} disabled={RouteParams['mode'] === 'view'} />
                                                </Form.Item>
                                                <Form.Item
                                                    initialValue= {item? item.status: false}
                                                    label="Active"  
                                                    name={'status'}    
                                                    rules={[]}>
                                                    {RouteParams['mode'] === 'view'?
                                                        <Switch disabled/>
                                                        :<Switch/>
                                                    }
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                        <hr/>
                                        <Row>
                                            <Col lg={10} md={10} sm={24} xs={24} className="mt-4">
                                                <h5>Security</h5>
                                                <p className="text-secondary">This Information will be display the identify of the administrator</p>
                                            </Col>
                                            
                                            <Col lg={14} md={14} sm={24} xs={24} className="mt-4">
                                                {
                                                    RouteParams['mode'] !== 'view' && <>
                                                        <Form.Item
                                                            label={t('user.password.label')}
                                                            name='password'
                                                            rules={[
                                                                {
                                                                    required: false,
                                                                    message: t('user.password.required'),
                                                                },
                                                                {
                                                                    min: RouteParams['mode'] === 'create' ? 6 : 0,
                                                                    message: t('user.password.minLength6'),
                                                                },
                                                            ]}
                                                        >
                                                            <Password className='br-1x'
                                                                onChange={() => {
                                                                    form.validateFields(['password_confirmation']);
                                                                }}
                                                            />
                                                        </Form.Item>
                                                        <Form.Item
                                                            label={t('user.password_confirmation.label')}
                                                            name='password_confirmation'
                                                            rules={[
                                                                ({ getFieldValue }) => ({
                                                                    validator(_, value) {
                                                                        if ((!getFieldValue('password') && !value) || getFieldValue('password') === value) {
                                                                            return Promise.resolve();
                                                                        }
                                                                        return Promise.reject(
                                                                            t('user.password.unmatched'),
                                                                        );
                                                                    },
                                                                }),
                                                            ]}
                                                        >
                                                            <Password className='br-1'
                                                            />
                                                        </Form.Item>
                                                    </>
                                                }
                                            </Col>
                                        </Row>
                                        <hr/>
                                        <Row>
                                            <Col lg={24} md={24} sm={24} xs={24}>
                                                {
                                                    RouteParams['mode'] !== 'view' && <Form.Item>
                                                        <Button
                                                            htmlType="submit"
                                                            loading={saving || uploading}
                                                            size={'large'}
                                                            className="submit btn-blue float-right"
                                                        >
                                                            {t('genDict.save')}
                                                        </Button>
                                                        <Button                                 
                                                            htmlType="reset"
                                                            size={'large'}
                                                            className="reset mr-3 btn-default float-right"
                                                        >
                                                            Cancel
                                                        </Button>
                                                    </Form.Item>
                                                }
                                            </Col>
                                        </Row>
                                    </Form>
                                </div>
                            </div>
                            :''
                        }
                        {console.log('itemsreturned',item)}
                        {RouteParams['mode'] === 'view' ?
                        
                            <div className='bg-white p-3 br-5px'>
                                <div className="row">
                                <div className="col-sm-6 pb-3">
                                    <div className="d-flex align-items-center">
                                        <div className="mr-3">
                                            {console.log(image)}
                                            { image.image !== '' ?
                                                <img src={image.image} className="uploaded-img-cat" height="50" width="50"/>
                                                :
                                                <img src={Parameters.ImageBaseUrl + 'avatar.png'} className="uploaded-img-cat" height="50" width="50"/>
                                            }
                                        </div>
                                        <div className=''>
                                        <h5 className="mb-0 font-18px"><span>{item?.name}</span></h5>
                                        </div>
                                    </div>
                                    
                                </div>
                                <div className="col-sm-6 pb-3 text-sm-right">
                                    <span className="text-secondary mr-4">{moment(item?.created_at).format('DD MMMM, YYYY')}</span>
                                    <span className="dropdown">
                                        <a role="button" className="dropdown-toggler" data-toggle="dropdown">
                                            <img src={vDOts} style={{width: '25px'}} />
                                        </a>
                                        <div className="dropdown-menu">
                                        <a className="dropdown-item" role="button"
                                            onClick={() => {
                                                history.push(`/admins/${item.id}/edit`);
                                            }}
                                        >Edit</a>
                                        <a className="dropdown-item" role="button"
                                        onClick={() => confirm({
                                            icon: <ExclamationCircleOutlined/>,
                                            title: t('genDict.confirmDelete'),
                                            okText: t('genDict.ok'),
                                            cancelText: t('genDict.cancel'),
                                            content: `${t('genDict.confirmDelete')} "${item.name}"`,
                                            okButtonProps: { loading: deletingItem, danger: true },
                                            onOk: async () => {
                                                setDeletingItem(true);
                                                API_SERVICE.removeUser(item.id).then((d) => {
                                                    notification.success({
                                                        message: t('genDict.success'),
                                                    });
                                                    // refreshItems();
                                                    history.push(`/admins/`);
                                                }).catch((e: any) => {
                                                    notification.error({
                                                        message: t(API_SERVICE.handleErrors(e)),
                                                    });
                                                }).finally(() => {
                                                    setDeletingItem(false);
                                                });
                                            },
                                        })
                                    }
                                        >Delete</a>
                                        </div>
                                    </span>
                                </div>
                                </div>
                                <div className="row">
                                <div className="col-md-12 pb-3">
                                    <div className="table-responsive mt-2">
                                        <table className="table course-details-table box-shadow">
                                            
                                            <tbody>
                                            <tr>
                                                <td className="w-280px text-secondary">Email Address</td>
                                                <td>
                                                    {item?.email}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="w-280px text-secondary">Phone Number</td>
                                                <td>
                                                    {item?.phone}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="w-280px text-secondary">Gender</td>
                                                <td>
                                                    {item?.gender}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="w-280px text-secondary">Organisation</td>
                                                <td>
                                                {item?.organization?.name}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="w-280px text-secondary">Type</td>
                                                <td>
                                                    {item?.type}
                                                </td>
                                            </tr>
                                            
                                            <tr>
                                                <td className="w-280px text-secondary">Active</td>
                                                <td>
                                                    {
                                                        item?.status === 1 ? 'YES' : 'No'
                                                    }
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                </div>
                            </div>
                        :''
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}
